<template>
    <div id="WorkOrderTemplateCreate" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="shopHeader" v-if="$route.params.id > 0">Update Work Order Template</span>
                    <span class="page-title" id="shopHeader" v-else>Add Work Order Template</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackWorkOrderTemplateList" >
                            <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content wo-template-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="WorkOrderTemplateForm">
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">        
                                        <label class="control-label require" for="location_id">Maintenance Type:</label>
                                        <v-select v-if="$route.params.id != undefined" v-model="maintenance_type_id" :disabled="true" name="maintenance_type_id" placeholder="Select Maintenance Type."
                                            label="text" class="close-remove" @input="maintenanceTypeChange($event)"
                                            :options="maintenanceTypeArr">
                                        </v-select>
                                        <v-select v-else v-model="maintenance_type_id" name="maintenance_type_id" placeholder="Select Maintenance Type."
                                            label="text" class="close-remove" @input="maintenanceTypeChange($event)"
                                            :options="maintenanceTypeArr">
                                        </v-select>
                                        <div class="field-error">{{ maintenance_type_error_msg }}</div>
                                    </div>

                                    <div class="col form-group" v-if="recallName">        
                                        <label class="control-label require" for="location_id">Recall Name:</label>
                                        <input type="text" class="form-control" placeholder="Enter Recall Name" v-model="recall"/>
                                        <div class="field-error">{{ recall_error_msg }}</div>
                                    </div>
                                </div>
                                <hr class="light-hr"/>
                                <div class="purchase-charges-deatil-label workorder-template-section"> 
                                    <h5 class="color-blue font-semibold">Template Item</h5>
                                    <div class="table-responsive-sm">
                                        <table aria-describedby="table" class="table table-sm table-bordered">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th scope="col">Component</th>
                                                    <th scope="col">Task</th>
                                                    <th scope="col" class="text-center">Action </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(template, index) in templateArr" :key="index">
                                                    <td style="width:40%">
                                                        <v-select v-model="template.item_category_id" name="item_category_id" placeholder="Select Component."
                                                                    label="text" class="close-remove"
                                                                    :options="vmrsArr" @search="onSearchVMRS" :filterable="false">
                                                        </v-select>
                                                        <div class="field-error">{{template.component_error_msg}}</div>
                                                    </td>
                                                    <td style="width:40%">
                                                        <v-select v-model="template.work_order_task_id" name="work_order_task_id" placeholder="Select Task."
                                                                    label="text" class="close-remove"
                                                                    :options="workOrderTaskArr">
                                                        </v-select>
                                                        <div class="field-error">{{template.task_error_msg}}</div>
                                                    </td>
                                                    <td class="text-center" valign="center">
                                                        <template v-if="templateArr.length != 1">
                                                            <i class="fp-close color-red close-icon cursor-pointer" v-on:click="removeLine(index)"> </i>
                                                        </template>
                                                        <template v-else>
                                                            <span class="close-row"> _ </span>
                                                        </template>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="btn-groups">
                                        <button type="submit" v-on:click.prevent="addLine()" class="btn btn-primary">
                                        <i class="fp-add"> </i> Add Template Item
                                    </button>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups mt-4">
                                    <button type="submit" id="createTemplateBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateWOTemplate" >
                                        <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createTemplateBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateWOTemplate" >
                                        <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueTemplateBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateWOTemplate(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="createAndContinueTemplateBtn" v-if="recallName" class="btn btn-tertiary" v-on:click.prevent="CreateWOTemplate(flag='Save and add')" >
                                        <i class="fp-save-continue"> </i>  Save and Add Asset
                                    </button>
                                    <button type="submit" id="cancelTemplateBtn" class="btn btn-tertiary" v-on:click.prevent="BackWorkOrderTemplateList" >
                                        <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import { contractMixins } from '../mixins/contractMixins';


export default {
  name: "WorkOrderTemplateCreate",
  metaInfo() {
    return {
        title: (this.$route.params.id > 0)? "Update Work Order Template | " +process.env.COPYRIGHT_NAME : "Create Work Order Template | " +process.env.COPYRIGHT_NAME
    }
  },
  
  mixins:[commonMixins, contractMixins],
  data: () => ({

    maintenance_type_id: null,
    maintenanceTypeArr: [],
    maintenance_type_error_msg: '',

    vmrsArr: [],
    workOrderTaskArr: [],
    templateArr: [],

    loading:false,
    permissions: [],
    cantAccessPage: "",
    recallName:false,
    recall:'',
    recall_error_msg:'',
    templateId:0,
    
  }),
  watch:{
        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_work_order_template') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['maintenance_type','workordertask']);

        self.templateArr.push({
            template_id:0,
            item_category_id: null,
            work_order_task_id: null,

            component_error_msg: "",
            task_error_msg: "",
        })

        if( self.$route.params.id){

            self.templateId = self.$route.params.id;
            self.loadTemplateData(self.templateId);
        }

  },
  methods: {

    maintenanceTypeChange(event){
        console.log("type chenged..."+JSON.stringify(event));

        var self = this;
        console.log('evt temp maintenance value => '+event.value)
        console.log('evt temp maintenance text => '+event.text)
        if(event.text == 'Recall'){
            self.recallName = true;
            return;
        }else{
            self.recallName = false;
        }
        self.loading = true;
        
        $.ajax({
            url: process.env.ROOT_API + "/workorder/get-workorder-template",
            type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType:"json",
            data:{
                maintenance_id: event.value
            },
            success: function (data) {
                self.loading = false;
                self.templateArr = [];
                if (data.code == 200) {

                    console.log("JSON Response = >" + JSON.stringify(data.content))

                    for ( var i=0; i<data.content.length; i++ ) {

                        self.templateArr.push({
                            template_id:(data.content[i].template_id != undefined && data.content[i].template_id != null && data.content[i].template_id != '')?data.content[i].template_id:0,
                            item_category_id: (data.content[i].component_category_id != undefined && data.content[i].component_category_id != null && data.content[i].component_category_id != '')?{value: data.content[i].component_category_id, text: self.titleCase(data.content[i].component_category_code + " | " + data.content[i].component_category_name)}:null,
                            work_order_task_id: (data.content[i].task_id != undefined && data.content[i].task_id != null && data.content[i].task_id != '')?{value: data.content[i].task_id, text: self.titleCase(data.content[i].task_name + " (" + data.content[i].task_code +")")}:null,
                            
                            task_error_msg: "",
                            component_error_msg: ""
                        })
                        
                    }

                    // if ( data.content[0] && data.content[0].recall_name){

                    //     self.recall = data.content[0].recall_name;

                    // }

                }else if(data.code = 201){
                    
                    self.templateArr.push({
                        template_id:0,
                        item_category_id: null,
                        work_order_task_id: null,

                        component_error_msg: "",
                        task_error_msg: "",
                    })

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR, true,'get-workorder-template');
            }
        });

    },

    loadTemplateData(id){

        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/workorder/get-template-data",
            type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType:"json",
            data:{
                template_id: id
            },
            success: function (data) {
                self.loading = false;
                self.templateArr = [];
                if (data.code == 200) {

                    console.log("JSON Response = >" + JSON.stringify(data.content))

                    for ( var i=0; i<data.content.length; i++ ) {

                        self.templateArr.push({
                            template_id:(data.content[i].template_id != undefined && data.content[i].template_id != null && data.content[i].template_id != '')?data.content[i].template_id:0,
                            item_category_id: (data.content[i].component_category_id != undefined && data.content[i].component_category_id != null && data.content[i].component_category_id != '')?{value: data.content[i].component_category_id, text: self.titleCase(data.content[i].component_category_code + " | " + data.content[i].component_category_name)}:null,
                            work_order_task_id: (data.content[i].task_id != undefined && data.content[i].task_id != null && data.content[i].task_id != '')?{value: data.content[i].task_id, text: self.titleCase(data.content[i].task_name + " (" + data.content[i].task_code +")")}:null,
                            
                            task_error_msg: "",
                            component_error_msg: ""
                        })
                        
                    }

                    if ( data.content[0] && data.content[0].recall_name){

                        self.recall = data.content[0].recall_name;

                    }
                    if ( data.content[0] && data.content[0].templateId){

                        self.maintenance_type_id = data.content[0].templateId;

                        if ( data.content[0].templateId.text == 'Recall'){
                            
                            self.recallName = true;
                        }

                    }

                }else if(data.code = 201){
                    
                    self.templateArr.push({
                        template_id:0,
                        item_category_id: null,
                        work_order_task_id: null,

                        component_error_msg: "",
                        task_error_msg: "",
                    })

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR, true,'get-wo-template');
            }
        });
    },

    BackWorkOrderTemplateList() {
      var self = this;
      self.$router.push("/workordertemplate/list");
    },

    CreateWOTemplate(flag) {

        var self = this;
        var error = false;

        self.maintenance_type_error_msg = "";
        self.recall_error_msg = "";
        
        if(self.recallName){
            if(self.recall == ''){
        
                self.recall_error_msg = "Recall Name Required.";
                error = true;

            }
        }
        if (!self.maintenance_type_id || self.maintenance_type_id == null || self.maintenance_type_id == "") {
            self.maintenance_type_error_msg = "Maintenance Type Required.";
            error = true;
        }

        for (var i=0; i<self.templateArr.length; i++) {

            self.templateArr[i].component_error_msg = "";
            self.templateArr[i].task_error_msg = "";

            if (self.templateArr[i].work_order_task_id == null || self.templateArr[i].work_order_task_id == "" || self.templateArr[i].work_order_task_id == 0) {
                self.templateArr[i].task_error_msg = "Task Required.";
                error = true;
            }

            if (self.templateArr[i].item_category_id == null || self.templateArr[i].item_category_id == "" || self.templateArr[i].item_category_id == 0) {
                self.templateArr[i].component_error_msg = "Component Required.";
                error = true;
            }

            

        }

      if (!error) {

            // PR - For Template Item
            var templateIdsArr = [];
            var componentArr = [];
            var taskArr = [];

            // alert('Array length..'+self.chargesArr.length);
            for (var i = 0; i<self.templateArr.length;i++) {

                templateIdsArr.push(self.templateArr[i].template_id);
                componentArr.push(self.templateArr[i].item_category_id.value);
                taskArr.push(self.templateArr[i].work_order_task_id.value);

            }

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createTemplateBtn").val("Updating ...");
                $("#createTemplateBtn").prop("disabled", true);
                $("#cancelTemplateBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue" || flag == "Save and add") {

                    $("#createAndContinueTemplateBtn").val("Saving ...");
                    $("#createTemplateBtn").prop("disabled", true);
                    $("#createAndContinueTemplateBtn").prop("disabled", true);
                    $("#cancelTemplateBtn").prop("disabled",true);

                }else{

                    $("#createTemplateBtn").val("Saving ...");
                    $("#createTemplateBtn").prop("disabled", true);
                    $("#createAndContinueTemplateBtn").prop("disabled", true);
                    $("#cancelTemplateBtn").prop("disabled",true);
                }
               
            }
            
            var fields = $("#WorkOrderTemplateForm").serializeArray();
            fields.push({name: "templateIdsArr", value: templateIdsArr});
            fields.push({name: "componentArr", value: componentArr});
            fields.push({name: "taskArr", value: taskArr});
            fields.push({ name: "id", value: segments[3] });
            fields.push({name: "maintenance_type_id", value: self.maintenance_type_id.value});

            if(self.recallName){

                fields.push({name: "recall_name", value: self.recall});
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/workordertemplate/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createTemplateBtn").val("Update");
                        $("#createTemplateBtn").prop("disabled", false);
                        $("#cancelTemplateBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueTemplateBtn").val("Save and Continue");
                            $("#createTemplateBtn").prop("disabled", false);
                            $("#createAndContinueTemplateBtn").prop("disabled", false);
                            $("#cancelTemplateBtn").prop("disabled",false);

                        }else{

                            $("#createTemplateBtn").val("Save");
                            $("#createTemplateBtn").prop("disabled", false);
                            $("#createAndContinueTemplateBtn").prop("disabled", false);
                            $("#cancelTemplateBtn").prop("disabled",false);
                        }
                    
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            self.maintenance_type_id = null;
                            self.templateArr = [];
                            self.templateArr.push({
                                template_id:0,
                                item_category_id: null,
                                work_order_task_id: null,
                                
                                task_error_msg: "",
                                component_error_msg: ""
                            })

                        }else if (flag == "Save and add"){

                            self.$router.push("/asset/list?from=recall");

                        }else{
                            self.$router.push("/workordertemplate/list");
                        }
                        
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createTemplateBtn").val("Update");
                        $("#createTemplateBtn").prop("disabled", false);
                        $("#cancelTemplateBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            self.name = "";  
                            $("#createAndContinueTemplateBtn").val("Save and Continue");
                            $("#createTemplateBtn").prop("disabled", false);
                            $("#createAndContinueTemplateBtn").prop("disabled", false);
                            $("#cancelTemplateBtn").prop("disabled",false);

                        }else{

                            $("#createTemplateBtn").val("Save");
                            $("#createTemplateBtn").prop("disabled", false);
                            $("#createAndContinueTemplateBtn").prop("disabled", false);
                            $("#cancelTemplateBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR, false,'workorder-template-create');
                }
            });
        }else{
            self.errorValidationFocus();
        }
    },

    loadWOTemplate() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/workordertemplate/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    
                    self.code = data.content.code;
                    self.name = data.content.name;
                    if(data.content.location_id == null){
                        self.location_id = null;
                    }else{
                        self.location_id = {value: data.content.location_id, text: self.titleCase(data.content.company_name)};
                    }
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR, false,'workorder-template-detail');
            }
        });
    },

    addLine () {

        var self = this;

        var index=self.templateArr.length-1;
        self.templateArr[index].task_error_msg = "";
        self.templateArr[index].component_error_msg = "";

        console.log('self.templateArr -> '+JSON.stringify(self.templateArr));

        if ( self.templateArr[index].item_category_id != null && self.templateArr[index].work_order_task_id != null ) {

            self.templateArr.push({
                template_id:0,
                item_category_id: null,
                work_order_task_id: null,
                
                task_error_msg: "",
                component_error_msg: ""
            })

        } else {

            if (self.templateArr[index].item_category_id == null || self.templateArr[index].item_category_id == "" ) {
                self.templateArr[index].component_error_msg = "Component Required.";
            }

            if (self.templateArr[index].work_order_task_id == null || self.templateArr[index].work_order_task_id == "") {
                self.templateArr[index].task_error_msg = "Task Required.";
            }

        }

    },

    removeLine (index) {

        var self = this;

        if (self.templateArr[index].template_id == 0) {
            self.templateArr.splice(index, 1);

        }
        else {

            if (confirm('Are you sure that you want to remove this line? ')) {

                $.ajax({
                    url: process.env.ROOT_API + "/workordertemplate/remove-item",
                    type: "POST",
                    data: {'id': self.templateArr[index].template_id},
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        if (data.status == "success") {
                            self.templateArr.splice(index, 1);
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR, true,'remove-workorder-template-item');

                    },
                });
            }
        }
    },
    onSearchVMRS(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'vmrs', '');
        }
    },
  }
};
</script>   


// WEBPACK FOOTER //
// src/components/WorkOrderTemplateCreate.vue